import { BodyText, Button, HeadlineText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";
import ShadowCard from "./ShadowCard";

// TODO: these types should move into pods/webviewInit/index when that is typescript
export interface ShareToStoryAction {
  type: "webview/shareToStory";
  payload: {
    photoUrl: string;
  };
}

type GoToLaunchpadFunction = () => void;
interface ShareToStoryProps {
  goToLaunchpad: GoToLaunchpadFunction;
  imageUrl: string;
  defaultCopy: string;
}

const ShareToStory: React.FC<ShareToStoryProps> = ({ imageUrl, goToLaunchpad, defaultCopy }) => {
  const text = defaultCopy;

  return (
    <div sx={appStyle}>
      <ShadowCard sx={cardStyle}>
        <div>
          <HeadlineText as="h3">All done!</HeadlineText>
          <BodyText kind="secondary" sx={descriptionStyle}>
            {text}
          </BodyText>
          <div sx={{ margin: RAW_cssValue("12px 0") }}>
            <img src={imageUrl} sx={{ width: "80%", maxWidth: "500px" }} alt="" />
          </div>
        </div>
      </ShadowCard>
      <Button data-name="share_to_story:modal_actions.done" onClick={goToLaunchpad} sx={buttonStyle}>
        Done
      </Button>
    </div>
  );
};

export default ShareToStory;

const appStyle: ThemeUIStyleObject = {
  textAlign: "center",
  padding: RAW_cssValue("20px"),
};

const descriptionStyle: ThemeUIStyleObject = {
  marginTop: "dt_s",
  marginBottom: "dt_l",
};

const cardStyle: ThemeUIStyleObject = {
  padding: "dt_m",
  maxWidth: "700px",
  margin: "auto",
};

const buttonStyle: ThemeUIStyleObject = {
  margin: "auto",
  width: "100%",
  maxWidth: "600px",
  marginTop: "s",
};
